var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.121,
    height: 15.804,
    viewBox: "0 0 17.121 15.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-calendar",
    "data-name": "Icon ionic-ios-calendar",
    transform: "translate(-3.375 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12159",
    "data-name": "Path 12159",
    d: "M18.85,6.75H17.2v.988a.33.33,0,0,1-.329.329h-.659a.33.33,0,0,1-.329-.329V6.75h-7.9v.988a.33.33,0,0,1-.329.329H7a.33.33,0,0,1-.329-.329V6.75H5.021A1.651,1.651,0,0,0,3.375,8.4V19.591a1.651,1.651,0,0,0,1.646,1.646H18.85A1.651,1.651,0,0,0,20.5,19.591V8.4A1.651,1.651,0,0,0,18.85,6.75ZM19.179,19.1a.826.826,0,0,1-.823.823H5.515a.826.826,0,0,1-.823-.823V11.689a.33.33,0,0,1,.329-.329H18.85a.33.33,0,0,1,.329.329Z",
    transform: "translate(0 -0.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12160",
    "data-name": "Path 12160",
    d: "M10.317,4.829A.33.33,0,0,0,9.988,4.5H9.329A.33.33,0,0,0,9,4.829v.988h1.317Z",
    transform: "translate(-2.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12161",
    "data-name": "Path 12161",
    d: "M26.067,4.829a.33.33,0,0,0-.329-.329h-.659a.33.33,0,0,0-.329.329v.988h1.317Z",
    transform: "translate(-8.863)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.352f474fbec96a980fc070e448389d25.svg";
export { ForwardRef as ReactComponent };